/** Try fn & args & return null on catch */
function TryNull<T>(fn: (...args: any[]) => T, ...args: any[]): T | null {
    try {
        return fn(...args);
    } catch (e) {
        return null;
    }
}

/** Try Async fn & args & return null on catch */
async function AsyncTryNull<T>(promise: Promise<T>): Promise<T | null> {
    return new Promise(async function (resolve, reject) {
        try {
            const result = await promise;
            resolve(result);
        } catch (error) {
            console.error(error);
            resolve(null);
        }
    });
}

/** get first non null item of property from #props array & return, otherwise return #U */
function getPropFallback<T, U>(object: any, props: Array<keyof T>, fallback: U): U {
    for (let idx = 0; idx < props.length; idx++) {
        const keySearch = props[idx];

        const val: U | null = (object as any)[keySearch];
        if (val) {
            return val;
        }
    }

    return fallback;
}

/** get first non null item from list & return */
function getFirstFallback<T>(...items: Array<T | null>): T | null {
    for (let idx = 0; idx < items.length; idx++) {
        const val = items[idx];

        if (val) {
            return val;
        }
    }

    return null;
}

const module = {
    TryNull,
    AsyncTryNull,
    getPropFallback,
    getFirstFallback,
};

export default module;
